export const sessionParameter = ()=>window._PROPZ_SESSION_ID ? `&_uzsk=${window._PROPZ_SESSION_ID}` : ''